export default __webpack_public_path__ + "static/media/steemit-github.b9cf7b6d.jpeg";